let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let radio = require("ES/lib/radio");
let esUtils = require("ES/utils/esUtils");
let Constants = require("../../../utils/Constants");
let RadioMixin = require("ES/lib/react-pubsub-via-radio.js/RadioMixin");
let DayPopover = require("./DayPopover");
let CalendarTools = require("./CalendarTools");
let AuthedUserSession = require("../../../utils/AuthedUserSession");

let MonthTitle = dd.createClass({
  __monthClicked: esUtils.wrapPreventDefault(function () {
    let {year, month} = this.props;
    radio("Show_Calendar").broadcast("month", new Date(year, month - 1, 1));
  }),
  render() {
    let {year, month} = this.props;
    return dd.a({href: "#", onClick: this.__monthClicked}, esUtils.get_month_name(month), dd.span(null, year));
  }
});

let Day = dd.createClass({
  mixins: [RadioMixin],
  getInitialState() {
    return {show_popover: false};
  },
  Radio_setup() {
    return {
      MiniCalendar_day_clicked(in_year, in_month, in_day) {
        let {year, month, day} = this.props;
        if ((in_year === year) && (in_month === month) && (in_day === (_.get(day, "date")))) {
        } else {
          this.setState({show_popover: false});//hide all others
        }
      },
      MiniCalendar_close_all_popovers() {
        if (this.state.show_popover) {
          this.setState({show_popover: false});
        }
      }
    };
  },
  __click_newEvent: esUtils.wrapPreventDefault(function () {
    let {year, month, day} = this.props;
    radio("Hashbang_set").broadcast("/events/new" + (!day ? "" : "/" + year + "-" + month + "-" + day.date));
    this.setState({show_popover: false});
  }),
  __click_toggle_popover: esUtils.wrapPreventDefault(function () {
    this.setState({show_popover: !this.state.show_popover});
  }),
  __click_url(url) {
    return _.bind(esUtils.wrapPreventDefault(function () {
      radio("Hashbang_set").broadcast(url);
      this.setState({show_popover: false});
    }), this);
  },
  __dayClicked(e) {
    let {year, month, day} = this.props;
    radio("MiniCalendar_day_clicked").broadcast(year, month, day.date);

    if (day.out_of_month) {
      return;
    }
    this.__click_toggle_popover(e);
  },
  render() {
    let {day, cal_data, cal_details, Displaylists, is_multi_sid_mode, include_other_companies, empire_mode} = this.props;
    let day_data = _.has(cal_data, day.date) ? cal_data[day.date] : {};

    let details = _.uniq(_.reject(_.map(day_data.detail_ids, function (detail_id) {
      return cal_details && cal_details[detail_id];
    }), _.isEmpty), function (detail) {
      if (detail.eid && detail.eid > 0) {
        return detail.eid;
      }
      return [detail.desc, detail.type].join("$");
    });

    let classes = ["day", "relative"];
    let decorators_classes = day_data.decorators;//TODO don't use day_data.decorators - why? b/c it doesn't filter by sid thus lots of stuff gets stomped over
    decorators_classes = _.without(decorators_classes, "personal");//don't use day_data.decorators why? b/c it doesn't filter by sid
    if (day.out_of_month) {
      classes.push("old");
    } else {
      classes.push("clickable");
      if ((_.some(details, function (detail) {
        //if there are any personal days...
        return _.get(detail, "psnl", false);
      })) && (!_.some(details, function (detail) {
        //...and there are no non-personal days
        return !_.get(detail, "psnl", false);
      }))) {
        //add personal...
        classes.push("personal");
        decorators_classes.push("personal");
      }
      if (!AuthedUserSession.is_st_family) {
        if (_.some(details, function (detail) {
          return _.get(detail, "vrtl", false);
        })) {
          classes.push("virtual");
          decorators_classes.push("virtual");
        }
      }

      //setting the day's status here includes status of every speaker, and we probably just want status for one
      let daystatus = -1;
      let has_other_company = false;
      _.each(details, function (detail) {
        if (
          (detail.type === "event")
          && ((daystatus < 0) || (Constants.EVENT_STATUS_PRIORITY[detail.sta] > Constants.EVENT_STATUS_PRIORITY[Constants.EVENT_STATUSES_by_num[daystatus]]))
          && (!AuthedUserSession.is_st_family || (!_.get(detail, "psnl", false) || _.includes(classes, "personal")))
        ) {
          daystatus = Constants.EVENT_STATUSES[detail.sta];
        }
        has_other_company = (has_other_company || (!_.include(_.get(AuthedUserSession, ["activeCompanyIds"]), _.parseInt(detail.cmpid)))) && !empire_mode; //in empire mode, there's not an 'other' company
      });
      if (daystatus > -1) {
        classes.push("cal-event");
        classes.push(Constants.EVENT_STATUSES_by_num[daystatus]);
      }
      if (has_other_company) {
        classes.push('othercompany');
      }
    }

    //ITEMS THAT WILL APPEAR IN THE POPUP MENU FOR THE DAY
    let popover_items = _.map(details, function (detail) {
      let url = CalendarTools.getEventURL(detail);
      let description = detail.desc;
      let personal = (detail.psnl ? "[PSNL] " : "");
      let name = (personal + description).trim();

      //EMPIRE MODE
      if (empire_mode) {
        let company = _.get(Displaylists, "universal.company", []).find(obj => {
          return obj.id == _.parseInt(detail.cmpid);
        });
        company = "[" + _.get(company, "abbr", ("COMPANY " + detail.cmpid)) + "] ";
        name = (company + personal + description).trim();
        url = CalendarTools.getEventURL(detail) + "/load"; //pecial EventTab state that will load the correct company

      } else {

        //EVENT COMPANY IS NOT THE ACTIVE COMPANY
        if (!_.include([_.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"])], detail.cmpid)) {
          let company = _.get(Displaylists, "universal.company", []).find(obj => {
            return _.parseInt(obj.id) === _.parseInt(detail.cmpid);
          });
          company = "[" + _.get(company, "abbr", ("COMPANY " + detail.cmpid)) + "] ";
          let location = (_.get(detail, "vcty", "") + " " + _.get(detail, "vst", "")).trim();
          if (location === '') {
            // if location is blank (i.e. no city or state), then use the country instead
            location = _.get(detail, "vcnt", "").trim();
          }
          if (location === '' || location === 'US') {
            // if the location is still blank, then just use the description
            location = 'TBD';
          }
          name = (company + personal + location).trim();
          if (!_.include(_.get(AuthedUserSession, ["companyIdsICanRead"]), _.parseInt(detail.cmpid))) {
            url = null; // Only remove the url if we can't read the event (or switch to a company and read the event)
          }
        }
      }

      return {
        sids: detail.sids,
        name: name,
        icon: CalendarTools.getEventIcon(detail),
        cmpid: detail.cmpid,
        className: CalendarTools.getEventClass(detail) + (detail.psnl ? ' personal' : ''),
        onClick: url ? this.__click_url(url) : null
      };
    }, this);
    popover_items.push({
      name: "Create new",
      onClick: this.__click_newEvent,
      className: _.isEmpty(popover_items) ? null : "popoverSeparator"
    });

    return dd.td({className: classes.join(" "), onClick: this.__dayClicked},
      dd.span(null, day.date),
      day.out_of_month ? null : _.map(decorators_classes, function (decorator, i) {
        return dd.div({key: i, className: "decorator " + decorator});
      }),
      !this.state.show_popover || popover_items.length === 0
        ? null
        : DayPopover({items: popover_items, Displaylists, is_multi_sid_mode, include_other_companies, empire_mode})
    );
  }
});

let weeksHaveMoreThanOneSID = function (cal_details, cal_data, weeks) {
  let da_one_sid = undefined;
  return _.some(weeks, function (week) {
    return _.some(week, function (day) {
      let day_data = _.has(cal_data, day.date) ? cal_data[day.date] : {};
      return _.some(day_data.detail_ids, function (detail_id) {
        let e = cal_details && cal_details[detail_id];
        return _.some(e && e.sids, function (sid) {
          let id = _.parseInt(sid, 10);
          if (da_one_sid === undefined) {
            da_one_sid = id;
          } else if ((id > 0) && da_one_sid !== id) {
            //we found more than one sid
            return true;
          }
          return false;
        });
      });
    });
  });
};

module.exports = dd.createClass({

  render() {
    let {year, month, cal_details, cal_data, Displaylists, include_other_companies, empire_mode} = this.props;
    let weeks = esUtils.build_calendar_weeks(year, month, true);
    let is_multi_sid_mode = weeksHaveMoreThanOneSID(cal_details, cal_data, weeks);

    return dd.div({className: "MiniCalendar"},
      dd.table(null,
        dd.thead(null,
          dd.tr(null,
            dd.th({colSpan: 7, className: "month"},
              MonthTitle({month, year})
            )
          ),
          dd.tr(null,
            _.map([1, 2, 3, 4, 5, 6, 7], function (d) {
              return dd.th({key: d, className: "dow"},
                esUtils.get_day_of_week(d, true)
              );
            })
          )
        ),
        dd.tbody(null,
          _.map(weeks, function (week, i) {
            return dd.tr({key: i},
              _.map(week, function (day, i) {
                return Day({
                  key: i,
                  year,
                  month,
                  day,
                  cal_data,
                  cal_details,
                  Displaylists,
                  is_multi_sid_mode,
                  include_other_companies,
                  empire_mode
                });
              })
            );
          })
        )
      )
    );
  }
});


// WEBPACK FOOTER //
// ./src/components/main_view/calendar_area/MiniCalendar.js